const featureFlags = {
  BLABLA_LANGUAGE:
    "Replaces translations with 'blabla'. Helps finding what's not translated.",
  GERMANY_ROLLOUT:
    "Germany rollout, hides Test buy, PQR and Shopping tool and poorly assembled type in product issue",
  ENABLE_DISCOVER_NOW: "Show discover now on homepage",
  ENABLE_TASK_MANAGEMENT: "Enables task management",
  ENABLE_CUSTOM_TASK_V2: "Enable custom task v2",
  ENABLE_TASK_MANAGEMENT_DEVELOPER: "Enables task management developer mode",
  ENABLE_PALLET_MULTIPACK_DATA_SERVICE:
    "Fetch pallet and multipack data from data service",
  ENABLE_PRODUCT_ISSUE_V2: "Enable product issue v2",
  ENABLE_ATKOMST:
    "Enable Åtkomst integration: unauthorized page, store switcher, and teams management Åtkomst stores",
  ENABLE_MEDIA_V2_TASKS:
    "Enable media maintenance single and multiple media task types",
  ENABLE_NEW_MEDIA_PIP_PAGE:
    "Enable new media pip page for media information landing page",
  ENABLE_LAUNCH_MEDIA: "Enable the Launch media page",
  ENABLE_MFAQ_FOLLOWUP_TASK_V2:
    "Enable MFAQ follow-up v2 task type in the new task management system",
  ENABLE_MEDIA_AI_ASSISTANT: "Enable media AI assistant in media details view",
  ENABLE_ADDON_ORDERS_V2: "Enable addon orders v2",
  ENABLE_KEY_SET_GET_TASKS:
    "Enable keyset pagination for GET /v2/tasks endpoint",
  ENABLE_REMAINING_MEDIA_TYPES:
    "Enable remaining media types: Product dominance wall, Selection point, Front media, Open the wallet, Opening offer",
  ENABLE_NEW_MEDIA_BADGES:
    "Enable NLP, Sustainability, NEWS, Family offer, 4A1K badges in media details view",
  ENABLE_TEAM_DELETE_TASK_HANDLING:
    "Enable reassigning and closing tasks when deleting a team, so team-owned tasks are handled before removal",
  ENABLE_TEAM_DELETE_USERS_HANDLING:
    "Enable reassigning and managing users when deleting a team, so team-owned users are handled before removal",
  ENABLE_DEXF: "Enable add DEFX articles in media",
  ENABLE_REMOVE_REOPEN_ACTION:
    "Hide reopen action from task menu for closed and completed tasks",
  ENABLE_BURST_DEBOUNCED: "Enable BurstDebounced",
  ENABLE_CWH_PREFERENCES_API: "Enable CWH preferences API integration",
};

export const FLAGS = Object.keys(featureFlags).reduce(
  (all, key) => ({ ...all, [key]: key }),
  {} as Record<keyof typeof featureFlags, string>
);
